<template>
  <v-tooltip bottom content-class="custom-tooltip">
    <template v-slot:activator="{ on, attrs }">
      <v-icon small v-bind="attrs" v-on="on" class="tooltip-icon">
        mdi-information-outline
      </v-icon>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>


<script>
export default {
  name: "helpicon",
  props: {
    tooltipText: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {},
  mounted() {

  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.custom-tooltip {
  max-width: 400px !important;
  white-space: normal;
  word-break: break-word;
  text-align: left;
  padding: 8px;
}

.tooltip-icon {
  cursor: pointer;
}
</style>